import { createContext } from "react";

const FactorsNeedPay2CompanyScreenContext = createContext<any>(null);

export default FactorsNeedPay2CompanyScreenContext;
